export default "__VITE_ASSET__TUe8VRjC__"